import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { useServerFn } from "@tanstack/react-start";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { exportarSESHospedajes } from "@/lib/viajeros.functions";

export const Route = createFileRoute("/_authenticated/gestion/viajeros")({
  component: SESHospedajesPage,
});

function today(offset = 0) {
  const d = new Date();
  d.setDate(d.getDate() + offset);
  return d.toISOString().slice(0, 10);
}

function SESHospedajesPage() {
  const exportar = useServerFn(exportarSESHospedajes);
  const [desde, setDesde] = useState(today(-7));
  const [hasta, setHasta] = useState(today());
  const [loading, setLoading] = useState(false);

  async function download() {
    setLoading(true);
    try {
      const { csv, total_viajeros, total_reservas } = await exportar({ data: { desde, hasta } });
      if (total_viajeros === 0) { toast.info("No hay viajeros registrados en ese rango"); return; }
      const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = `ses-hospedajes-${desde}_${hasta}.csv`; a.click();
      URL.revokeObjectURL(url);
      toast.success(`${total_viajeros} viajeros de ${total_reservas} reservas exportados`);
    } catch (e) { toast.error((e as Error).message); }
    finally { setLoading(false); }
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-serif text-2xl">SES.Hospedajes</h1>
        <p className="text-sm text-muted-foreground">
          Registro obligatorio de viajeros del Ministerio del Interior (RD 933/2021). Exporta un CSV con los viajeros y reservas del rango de fechas seleccionado.
        </p>
      </div>
      <Card>
        <CardHeader><CardTitle className="text-lg">Exportar registro</CardTitle></CardHeader>
        <CardContent className="space-y-4">
          <div className="grid gap-3 md:grid-cols-3">
            <div><Label>Desde (fecha entrada)</Label><Input type="date" value={desde} onChange={(e) => setDesde(e.target.value)} /></div>
            <div><Label>Hasta (fecha entrada)</Label><Input type="date" value={hasta} onChange={(e) => setHasta(e.target.value)} /></div>
            <div className="flex items-end"><Button className="w-full" onClick={download} disabled={loading}><Download className="mr-2 h-4 w-4" />{loading ? "Generando…" : "Descargar CSV"}</Button></div>
          </div>
          <p className="text-xs text-muted-foreground">
            El CSV incluye los datos obligatorios de cada viajero (nombre, documento, nacionalidad, fecha de nacimiento, dirección) y de la reserva (fechas, importe, método de pago). Puedes importarlo en la plataforma SES.Hospedajes o entregarlo a tu gestor.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}